import { v4 as uuidv4 } from "uuid";

const exampleCV = {
  personalInfo: {
    firstName: "",
    lastName: "",
    title: "",
    photo: "",
    // address: "",
    phoneNumber: "",
    email: "",
    linkedIn: "",
    website: "",
    objective: "",
  },
  projects: [
    {
      id: uuidv4(),
      projectTitle: "",
      from: "",
      to: "",
      description: "",
    },
  ],
  experience: [
    {
      id: uuidv4(),
      position: "",
      company: "",
      city: "",
      from: "",
      to: "",
      description: "",
    },
  ],
  education: [
    {
      id: uuidv4(),
      universityName: "",
      city: "",
      degree: "",
      subject: "",
      from: "",
      to: "",
      description: "",
    },
  ],
};

export default exampleCV;
